<template>
  <div>
    <div class="text-right">
      <el-radio-group v-model="languageName" size="small" class="mr-10">
         <el-radio-button size="small" v-for="l in cms_languages" :key="l.id" :label="l.name" :value="l.code"></el-radio-button>
       </el-radio-group>
       <el-tooltip class="item" effect="dark" :content="editTooltip" placement="top">
         <el-button size="small" icon="el-icon-edit" @click="handleEdition"></el-button>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" :content="duplicateTooltip" placement="top">
        <el-button size="small" icon="mdi mdi-content-copy" @click="handleDuplicate"></el-button>
      </el-tooltip>
      <el-tooltip effect="dark" :content="deleteTooltip" placement="top">
        <el-button size="small" icon="el-icon-delete" @click="handleDeleteProductItem"></el-button>
      </el-tooltip>

    </div>
    <el-row v-if="productItem!=null" class="mt-20 mb-20">
      <el-col :xs="8" :sm="6" :md="6" :lg="6" :xl="6" class="text-center">
        <el-image v-if="productItem.image!=null" :lazy="true" fit="scale-down" :src="productItem.image.link" style="height:200px;"/>
      </el-col>
      <el-col :xs="16" :sm="18" :md="18" :lg="18" :xl="18">
        <el-row>
          <el-col class="m-2">
            <span class="fs-14">{{$t('CMSProduct.releaseYear')}} : <span class="fs-15 secondary-text">{{productItem.releaseYear}}</span></span>
          </el-col>
          <el-col class="m-2">
            <span class="fs-14">{{$t('CMSProduct.web_site')}} : <span class="fs-15 secondary-text"><el-link target="_blank" :href="'http://'+productItem.webSite">{{productItem.webSite}}</el-link></span></span>
          </el-col>
        </el-row>
      </el-col>

    </el-row>
    <el-table
      :data="specifications"
      :cell-style="{padding:'2px'}"
      style="width: 100%">
      <el-table-column
        prop="label"
        fixed
        label="Attribut">
      </el-table-column>
      <el-table-column
        prop="value"
        label="Valeur">
        <template slot-scope="props">
          <span style="white-space: normal;">{{props.row.value}}</span>
      </template>
        
      </el-table-column>
    </el-table>
  </div>
</template>
<script>

import cmsAPI from '@/services/API/cmsAPI'
import { mapActions, mapState, mapGetters } from 'vuex';
import { EventBus } from '@/core/event-bus'

export default {
	name: 'ProductItemSpecification',
  props : {
    productItemId : {type : Number, required:true},
  },
	data() {
		return {
      productItem : null,
      languageName : 'Français'
		}
	},
  components : {

  },
  computed : {
    duplicateTooltip () {
      return this.$i18n.t('CMSProduct.duplicate_tooltip')
    },
    deleteTooltip () {
      return this.$i18n.t('CMSProduct.delete_tooltip');
    },
    editTooltip () {
      return this.$i18n.t('CMSProduct.edit_tooltip');
    },
    languageShowed(){
      return _.find(this.cms_languages, l=>{return l.name==this.languageName})
    },
    cms_languages(){
      return _.filter(this.languages, l=>{return l.cms_language});
    },
    lang(){
      return this.$i18n.locale
    },
    specifications(){
      let table = [];
      if(this.productItem==null)return table;
      _.forEach(this.productItem.properties, p=>{
        table.push({label : p.label.label[this.languageShowed.code], value : p.value.value[this.languageShowed.code]});
      })
      _.forEach(this.productItem.unusedPropertyLables, p => {
        table.push({label : p.label.label[this.languageShowed.code], value : p.value.value[this.languageShowed.code]});
      })
      return table;
    },
    ...mapState('controlData',['languages']),
  },
  methods : {
    handleDuplicate () {
      this.$emit('duplicate', this.productItemId)
    },
    handleEdition(){
      this.$emit('edit', this.productItemId)
    },
    handleDeleteProductItem(){
      this.$confirm(this.$i18n.t('CMSProduct.delete_confirmation_msg'), 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Annuler',
          type: 'warning'
        }).then(()=>{
          return this.deleteProductItem(this.productItemId)
        }).catch(err=>{
          if(err=="cancel"){
            this.$message(this.$i18n.t('CMSProduct.productItem_deletion_cancelled_msg'))
          }
        })
    },
    deleteProductItem(productItemId){
      return cmsAPI.deleteCMSProductItem(productItemId)
        .then(()=>{
          this.$message({type: 'success',message: this.$i18n.t('CMSProduct.productItem_deletion_confirmed_msg')});
          this.$emit('delete',productItemId);
        }).catch(err=>{
          this.$message.error(this.$i18n.t('CMSProduct.productItem_deletion_failed_msg'))
        })
    },
    fetchProductItem(productItemId, lang){
      return cmsAPI.getCMSProductItem(productItemId)
        .then(productItem=>{
          this.productItem = productItem;
        })
    },
    handleProductItemUpdated(productItemUpdatedId){
      if(this.productItemId==productItemUpdatedId){
        this.fetchProductItem(productItemUpdatedId);
      }
    },
    ...mapActions('controlData',['fetchLanguages']),
  },
  mounted(){
    return Promise.all([
      this.fetchLanguages(),
      this.fetchProductItem(this.productItemId, this.lang)
    ])

  },
  created(){
    EventBus.$on('product-item-updated', this.handleProductItemUpdated );
  }
}
</script>
<style lang="scss" scoped>
// @import '../../../../assets/scss/_variables';



</style>
